import * as fromDatatype from '../datatype-library';

export interface bl_fi_item_view_hdr_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    item_hdr_guid: fromDatatype.GuidDataFieldInterface;
    fk_table_name: fromDatatype.VarcharArrayDatatypeInterface;
    fk_table_guid: fromDatatype.GuidDataFieldInterface;
    login_subject_guid: fromDatatype.GuidDataFieldInterface;
    cookie: fromDatatype.GuidDataFieldInterface;
    view_count: fromDatatype.NumericDatatypeInterface;
    latest_time: fromDatatype.TimestampTzDatatypeInterface;
    name: fromDatatype.VarcharArrayDatatypeInterface;
    code: fromDatatype.VarcharArrayDatatypeInterface;
    descr: fromDatatype.VarcharArrayDatatypeInterface;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    status: fromDatatype.StatusDataFieldInterface;
    revision: fromDatatype.RevisionDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
}

export class bl_fi_item_view_hdr_RowClass implements bl_fi_item_view_hdr_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    item_hdr_guid: fromDatatype.GuidDataFieldInterface;
    fk_table_name: fromDatatype.VarcharArrayDatatypeInterface;
    fk_table_guid: fromDatatype.GuidDataFieldInterface;
    login_subject_guid: fromDatatype.GuidDataFieldInterface;
    cookie: fromDatatype.GuidDataFieldInterface;
    view_count: fromDatatype.NumericDatatypeInterface;
    latest_time: fromDatatype.TimestampTzDatatypeInterface;
    name: fromDatatype.VarcharArrayDatatypeInterface;
    code: fromDatatype.VarcharArrayDatatypeInterface;
    descr: fromDatatype.VarcharArrayDatatypeInterface;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    status: fromDatatype.StatusDataFieldInterface;
    revision: fromDatatype.RevisionDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
}
